var _excluded = ["children", "alignItems", "justifyContent", "inset", "gap"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled from "styled-components";
import { replaceToken } from "../../private/helpers";
import forwardRef from "../../private/forwardRef";
var StackContainer = styled.div.withConfig({
  displayName: "Stack__StackContainer",
  componentId: "sc-agfvon-0"
})(["display:flex;flex-direction:column;justify-content:", ";align-items:", ";padding:", ";& > *:not(:last-child){margin-bottom:", ";}"], props => props.$justifyContent, props => props.$alignItems, _ref => {
  var {
    theme,
    $inset
  } = _ref;
  return replaceToken(theme.spacing, $inset);
}, _ref2 => {
  var {
    theme,
    $gap
  } = _ref2;
  return replaceToken(theme.spacing, $gap);
});

/**
 * This lays child components vertically.
 *
 * @see [Stack documentation](https://construct-kit.reainternal.net/components/web/core/stack)
 */
var Stack = forwardRef((_ref3, ref) => {
  var {
      children,
      alignItems = "stretch",
      justifyContent = "flex-start",
      inset = "0",
      gap = "1.5rem"
    } = _ref3,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(StackContainer, _extends({
    ref: ref,
    $alignItems: alignItems,
    $justifyContent: justifyContent,
    $inset: inset,
    $gap: gap
  }, props), children);
});
Stack.displayName = "Stack";
export default Stack;